import { Box, Typography, Button, TextField, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import useMediaQuery from "@mui/material/useMediaQuery";
import LoadingButton from "@mui/lab/LoadingButton";
// import { useEffect } from 'react'
const PixMail = ({
	handleChangeEmail,
	clientMail,
	isValidMail,
	handleStep
}) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const isNonMobile = useMediaQuery("(min-width: 800px)");


	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="center"
			sx={{
				width: "100%",
				height: "100vh",
			}}
		>
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				flexDirection="column"
				p="10px"
				sx={{
					gap: "30px",
					width: "100%"
				}}
			>
				<Typography variant="h3" color={colors.primary[100]}>
					Insira o E-mail do Cliente
				</Typography>
				<TextField
					fullWidth
					variant="outlined"
					type="email"
					label="Inisra o email do cliente"
					onChange={handleChangeEmail}
					value={clientMail}
					name="email"
					required={true}
					helperText={
						isValidMail || clientMail.length === 0 ? "" : "Preencha com um e-mail válido"
					}
					pattern="/^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/"
					error={!isValidMail && clientMail.length > 0}
					sx={{
						width: isNonMobile ? "50%" : "100%",
						fontSize: "20px",
						borderRadius: "4px",
						"& .MuiInputBase-root": {
							backgroundColor: `${colors.pink[600]} !important`
						},
						"& .MuiFormHelperText-root.Mui-error": {
							color: 'yellow',
							fontStyle: "italic"
						},
						"& MuiInputBase-root.Mui-focused": {
							color: `${colors.grey[200]} !important`,
							fontWeight: "bold"
						},
						"& .MuiFormLabel-root.Mui-focused": {
							color: `${colors.grey[200]} !important`,
							fontWeight: "bold",
							fontSize: "12px"
						}
					}}
				/>
				<LoadingButton
					loading={false}
					type="submit"
					sx={{
						backgroundColor: colors.greenAccent[600],
						width: isNonMobile ? "50%" : "100%",
						borderRadius: "60px"
					}}
					variant="contained"
					disabled={!isValidMail}
					onClick={handleStep}

				>
					Gerar Pix
				</LoadingButton>
			</Box>
		</Box>
	);
};

export default PixMail;
